const FILE = {
  FORMAT: {
    PICTURES: ['jpg', 'jpeg', 'png', 'svg', 'gif', 'webp', 'bmp', 'tiff'],
    VIDEOS: ['mp4'],
    AUDIOS: ['mp3'],
    DOCUMENTS: ['pdf', 'txt'],
    SHEET: ['xlsx'],
  },
  UNIT: {
    DEFAULT: {
      KILOBYTE: 1_000,
      SIZES: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'],
    },
    EN: {
      B: 'B',
      KB: 'KB',
      MB: 'MB',
      GB: 'GB',
      TB: 'TB',
      PB: 'PB',
      EB: 'EB',
    },
    FA: {
      B: 'بایت',
      KB: 'کیلوبایت',
      MB: 'مگابایت',
      GB: 'گیگابایت',
      TB: 'ترابایت',
      PB: 'پتابایت',
      EB: 'اگزابایت',
    },
  },
  IMAGE: {
    SIZE: {
      WIDTH: 1080,
      HEIGHT: 1920,
    },
  },
  VIDEO: {
    SIZE: {
      WIDTH: 1080,
      HEIGHT: 1920,
    },
  },
  AUDIO: {
    SIZE: {
      WIDTH: 1080,
      HEIGHT: 1920,
    },
  },
  DOCUMENT: {
    SIZE: {
      WIDTH: 1080,
      HEIGHT: 1920,
    },
  },
  IFRAME: {
    SIZE: {
      WIDTH: 1080,
      HEIGHT: 1920,
    },
  },
} as const;

export { FILE };
